import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { SearchParam, SearchParamType } from '../../search-param.model';
import { labelTranslationKeyToFromToLabel, labelTranslationKeyToString } from '../../helpers';
import { FILTER_PER_ROW } from '../settings';

@Component({
    selector: 'se-ap-filters-row',
    templateUrl: './ap-filters-row.component.html',
    styleUrls: ['./ap-filters-row.component.scss'],
})
export class ApFiltersRowComponent implements OnInit, OnDestroy {
    filterWidth: string = '';
    protected readonly SearchParamType = SearchParamType;

    labelTranslationKeyToString = labelTranslationKeyToString;

    labelTranslationKeyToFromToLabel = labelTranslationKeyToFromToLabel;

    private destroyed$ = new Subject<void>();

    @Input() rowSize$: BehaviorSubject<number> | null = null;

    @Input() searchParams: SearchParam[] = [];

    @Output()
    filterChanged = new EventEmitter<{ name: string; idx: number }>();

    @Output()
    resetComboValue = new EventEmitter<{ name: string; idx: number }>();

    @Input()
    onSelectFiltering: (filterName: string, idx: number, $event: MouseEvent) => void = () => {};

    @Input()
    onSearch: () => void = () => {};

    @Input()
    onFromToErrorChange: ($event: any) => void = () => {};

    onEnterKeyDown(e: Event) {
        e.preventDefault();
        this.onSearch();
    }

    onFilterChange(name: string, idx: number) {
        this.filterChanged.emit({ name, idx });
    }

    resetComboSelectedValue(filterName: string, idx: number, $event: MouseEvent) {
        $event.stopPropagation();
        this.resetComboValue.emit({ name: filterName, idx });
    }

    ngOnInit() {
        this.rowSize$?.pipe(takeUntil(this.destroyed$)).subscribe((size) => {
            setTimeout(() => (this.filterWidth = (size - 2 - 16 * FILTER_PER_ROW) / FILTER_PER_ROW + 'px'));
        });
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
